export const APIZOOM_GOOGLE_PLAY =
  'https://play.google.com/store/apps/details?id=com.apizoom';
export const APIZOOM_APPLE_STORE =
  'https://apps.apple.com/app/apizoom/id1470929811';

export const TYPEFORM_SURVEY_FR = 'https://gcionicdev.typeform.com/to/lcRGSd';
